/* Darinka · SKU real para buscador cabecera · 03-10-2026 */
(function(){
  if(window.__dkNavsearchLuxury20261003)return;
  window.__dkNavsearchLuxury20261003=true;
  var cache=Object.create(null);
  function pickSku(data){
    var variants=(data&&data.variants)||[];
    var v=variants.find(function(x){return x&&x.available&&String(x.sku||'').trim();})||variants.find(function(x){return x&&String(x.sku||'').trim();});
    return v?String(v.sku).trim():'';
  }
  function getSku(path){
    if(cache[path])return cache[path];
    cache[path]=fetch(path+'.js',{headers:{Accept:'application/json'},credentials:'same-origin'})
      .then(function(r){if(!r.ok)throw new Error('product-json');return r.json();})
      .then(pickSku)
      .catch(function(){return '';});
    return cache[path];
  }
  function hydrate(item){
    if(!item||item.dataset.dkSkuBound==='1')return;
    item.dataset.dkSkuBound='1';
    var href=item.getAttribute('href')||'';
    if(!href)return;
    var path='';
    try{var u=new URL(href,window.location.origin);if(u.origin!==window.location.origin)return;path=u.pathname.replace(/\/$/,'');}catch(e){return;}
    if(!/\/products\//.test(path))return;
    getSku(path).then(function(sku){
      if(!sku||!item.isConnected)return;
      var el=item.querySelector('.ns-sku');
      if(!el){el=document.createElement('span');el.className='ns-sku';item.appendChild(el);}
      el.textContent='SKU · '+sku;
      el.setAttribute('aria-label','SKU '+sku);
    });
  }
  function enhance(panel){panel.querySelectorAll('.ns-item').forEach(hydrate);}
  function boot(){
    document.querySelectorAll('[data-navsearch] .navsearch-panel').forEach(function(panel){
      if(panel.dataset.dkLuxuryObserved==='1')return;
      panel.dataset.dkLuxuryObserved='1';
      enhance(panel);
      if('MutationObserver'in window)new MutationObserver(function(){enhance(panel);}).observe(panel,{childList:true,subtree:true});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();
